
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1r9lg_16bk7_153",
  "drawer-closed": "awsui_drawer-closed_1r9lg_16bk7_190",
  "refresh": "awsui_refresh_1r9lg_16bk7_190",
  "drawer-content-side": "awsui_drawer-content-side_1r9lg_16bk7_195",
  "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_16bk7_211",
  "position-bottom": "awsui_position-bottom_1r9lg_16bk7_218",
  "hidden": "awsui_hidden_1r9lg_16bk7_226",
  "position-side": "awsui_position-side_1r9lg_16bk7_247",
  "with-toolbar": "awsui_with-toolbar_1r9lg_16bk7_252",
  "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_16bk7_256",
  "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_16bk7_267",
  "open-button-side": "awsui_open-button-side_1r9lg_16bk7_281",
  "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_16bk7_290",
  "drawer-mobile": "awsui_drawer-mobile_1r9lg_16bk7_300",
  "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_16bk7_304",
  "content-bottom": "awsui_content-bottom_1r9lg_16bk7_316",
  "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_16bk7_335",
  "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_16bk7_340",
  "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_16bk7_344",
  "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_16bk7_348",
  "content-side": "awsui_content-side_1r9lg_16bk7_353",
  "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_16bk7_365",
  "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_16bk7_374",
  "header": "awsui_header_1r9lg_16bk7_385",
  "header-text": "awsui_header-text_1r9lg_16bk7_398",
  "header-actions": "awsui_header-actions_1r9lg_16bk7_411",
  "divider": "awsui_divider_1r9lg_16bk7_419"
};
  